import { connect } from "react-redux";

import { authorized } from "MODULES/shared/decorators";
import { USER } from "MODULES/users/constants";
import { ID } from "APP_ROOT/constants";
import Fields from "./Fields";

const select = (state, ownProps) => ({
  canEdit:
    ownProps.isNew ||
    state.session.getIn([USER, ID]) !== state.userDetail.getIn([USER, ID])
});

export function adminFields(Component) {
  return authorized()(connect(select)(Component));
}

export default adminFields(Fields);



// WEBPACK FOOTER //
// ./app/modules/users/components/Admin/AdminFields.jsx